export enum SeverityLevelEnum {
  Info = 'info',
  Success = 'success',
  Warning = 'warn',
  Error = 'error'
}
